import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import { Text } from '@chakra-ui/react';

const PanelsSearch = ({ items, setResult, defaultValue, fabric = false }) => {
  // note: the id field is mandatory

  const handleOnSearch = (string, results) => {
    console.log(string, results);
  };

  const handleOnHover = result => {};

  const handleOnSelect = item => {
    !fabric ? setResult(item.id) : setResult(item.number);
  };

  const handleOnFocus = () => {
    console.log('Focused');
  };

  const formatResult = item => {
    return (
      <>
        <span style={{ display: 'block', textAlign: 'left' }}>
          адрес: {item.name}
        </span>
        <span style={{ display: 'block', textAlign: 'left' }}>
          номер: {item.number}
        </span>
      </>
    );
  };

  return (
    <div
      style={{
        width: 400,
        marginTop: '8px',
        marginBottom: '8px',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      }}
    >
      <Text>Панель</Text>
      <ReactSearchAutocomplete
        inputSearchString={defaultValue}
        items={items}
        onSearch={handleOnSearch}
        onHover={handleOnHover}
        onSelect={handleOnSelect}
        onFocus={handleOnFocus}
        autoFocus
        formatResult={formatResult}
        showIcon={false}
        styling={{ borderRadius: '8px', zIndex: 99999 }}
        maxResults={10}
      />
    </div>
  );
};

export default PanelsSearch;
